export enum RaffleDefaultDrawLotteryReasonEnum {
  LOCAL_RESULT_OUTDATED = "LOCAL_RESULT_OUTDATED",
  EXTERNAL_API_UNAVAILABLE = "EXTERNAL_API_UNAVAILABLE",
  LOTTERY_RESULT_UNAVAILABLE = "LOTTERY_RESULT_UNAVAILABLE",
}

export type RaffleDefaultDrawLotteryReasonTypes =
  `${RaffleDefaultDrawLotteryReasonEnum}`;
